import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const services = [
  {
    label: 'Trasferimenti da e per aeroporti',
    value: 'trasferimenti-aeroporti',
  },
  {
    label: 'Trasferimenti aziendali e meeting',
    value: 'trasferimenti-aziendali-meeting',
  },
  { label: 'Viaggi su lunghe distanze', value: 'viaggi-lunghe-distanze' },
  {
    label: 'Matrimoni ed eventi speciali',
    value: 'matrimoni-eventi-speciali',
  },
  {
    label: 'Visite guidate in Franciacorta',
    value: 'visite-guidate-franciacorta',
  },
  {
    label: 'Outlet Village',
    value: 'outlet-franciacorta-village',
  },
  { label: 'Altro', value: 'other' },
];

export default function Contacts() {
  /*const [formData, setFormData] = React.useState({
    nomeCognome: '',
    cellulare: '',
    email: '',
    servizio: servizi[0],
    data: '',
    orario: '',
    messaggio: '',
  });*/

  /*
  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  */

  /*
  const handleSubmit = async e => {
    e.preventDefault();
    try {
      await addDoc(collection(db, 'richiesteContatto'), {
        ...formData,
        createdAt: serverTimestamp(),
      });
      console.log('Dati salvati su Firestore');

      
      e.target.submit();
    } catch (error) {
      console.error('Errore salvataggio Firestore:', error);
      alert('Errore nel salvataggio, riprova più tardi.');
    }
  };
  */

  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [state, setState] = useState({
    form: {
      message: '',
      lastName: '',
      firstName: '',
      service: '',
      telephone: '',
      email: '',
      datetime: '',
    },
  });

  React.useEffect(() => {
    setState(s => ({ ...s, form: { ...s.form, service: location.state?.service } }));
  }, [location.state]);

  const [errors, setErrors] = useState({
    email: '',
    firstName: '',
    lastName: '',
    message: '',
  });

  const validateForm = () => {
    const newErrors = {};
    if (!state.form.firstName.trim()) newErrors.firstName = 'Please fill in your first name';
    if (!state.form.lastName.trim()) newErrors.lastName = 'Please fill in your last name';
    if (!state.form.message.trim()) newErrors.message = 'Please fill in your message';
    if (!state.form.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.form.email)) {
      newErrors.email = 'Please fill in a valid email address';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  function encode(data) {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
      .join('&');
  }

  const handleSubmit = async e => {
    if (validateForm()) {
      e.preventDefault();
      setIsLoading(true);

      const body = {
        'form-name': 'contact',
        firstName: state.form.firstName,
        lastName: state.form.lastName,
        email: state.form.email,
        telephone: state.form.telephone,
        datetime: new Date(state.form.datetime).toLocaleString('it-IT', {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        }),
        service: services.find(service => service.value === state.form.service)?.label,
        message: state.form.message,
      };

      fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: encode(body),
      })
        .then(result => {
          console.info(result);
          setTimeout(() => {
            navigate('/thank-you', {
              state: body,
            });
          }, 1500);
        })
        .catch(err => {
          console.error(err);
          setIsLoading(false);
        });
    }
  };

  const handleFormChange = e => {
    setState(state => {
      let { form } = state;
      form = { ...form, [e.target.name]: e.target.value };
      return { ...state, form: form };
    });
  };

  return (
    <>
      <div className="relative bg-white">
        <div className="lg:absolute lg:inset-0 lg:left-1/2">
          <a href="https://it.freepik.com/foto-gratuito/colleghi-che-lavorano-insieme-in-un-ufficio-del-call-center-con-il-caffe_22196726.htm#fromView=search&page=2&position=1&uuid=1ee1d6a6-265a-43aa-9fb3-bea4182667d4&query=help+desk+contact+auto+driver">
            <img
              alt="colleghi-che-lavorano-insieme-un-ufficio-del-call-center-con-il-caffe"
              src="/img/colleghi-che-lavorano-insieme-un-ufficio-del-call-center-con-il-caffe.jpg"
              className="h-64 w-full bg-gray-50 object-cover sm:h-80 lg:absolute lg:h-full"
            />
          </a>
        </div>
        <div className="pb-24 pt-16 sm:pb-32 sm:pt-24 lg:mx-auto lg:grid lg:max-w-7xl lg:grid-cols-2 lg:pt-32">
          <div className="px-6 lg:px-8">
            <div className="mx-auto max-w-xl lg:mx-0 lg:max-w-lg">
              <h2 className="text-pretty text-4xl font-semibold tracking-tight text-gray-900 dark:text-white sm:text-5xl">
                Hai bisogno di un trasferimento?
              </h2>
              <p className="mt-2 text-lg/8 text-gray-600 dark:text-gray-400">
                Inviaci la tua richiesta e ti ricontatteremo in breve tempo con tutti i dettagli.
              </p>
              {/* 🔥 OVERLAY LOADING */}
              {isLoading && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
                  <div className="flex flex-col items-center gap-4">
                    <svg
                      className="size-10 animate-spin text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      />
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 000 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
                      />
                    </svg>
                    <p className="text-lg font-medium text-white">Invio in corso…</p>
                  </div>
                </div>
              )}
              <form
                name="contact"
                id="contact-form"
                data-netlify="true"
                data-netlify-recaptcha="true"
                method="POST"
                //action={'/thank-you'}
                onSubmit={handleSubmit}
                className="mt-16"
              >
                <input type="hidden" name="form-name" value="contact" />
                <div data-netlify-recaptcha="true"></div>
                <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
                  <div>
                    <label
                      htmlFor="first-name"
                      className="block text-sm/6 font-semibold text-gray-900 dark:text-white"
                    >
                      Nome
                    </label>
                    <div className="mt-2.5">
                      <input
                        required
                        id="first-name"
                        name="firstName"
                        type="text"
                        value={state.form.firstName}
                        onChange={handleFormChange}
                        autoComplete="given-name"
                        className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary dark:bg-white/5 dark:text-white dark:outline-white/10 dark:placeholder:text-gray-500 dark:focus:outline-primary"
                      />
                      <div>
                        {errors.firstName && (
                          <p className="text-sm text-red-500">{errors.firstName}</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div>
                    <label
                      htmlFor="last-name"
                      className="block text-sm/6 font-semibold text-gray-900 dark:text-white"
                    >
                      Cognome
                    </label>
                    <div className="mt-2.5">
                      <input
                        required
                        id="last-name"
                        name="lastName"
                        value={state.form.lastName}
                        onChange={handleFormChange}
                        type="text"
                        autoComplete="family-name"
                        className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary dark:bg-white/5 dark:text-white dark:outline-white/10 dark:placeholder:text-gray-500 dark:focus:outline-primary"
                      />
                      <div>
                        {errors.lastName && (
                          <p className="text-sm text-red-500">{errors.lastName}</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="sm:col-span-2">
                    <label
                      htmlFor="email"
                      className="block text-sm/6 font-semibold text-gray-900 dark:text-white"
                    >
                      Email
                    </label>
                    <div className="mt-2.5">
                      <input
                        id="email"
                        name="email"
                        value={state.form.email}
                        onChange={handleFormChange}
                        type="email"
                        autoComplete="email"
                        className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary dark:bg-white/5 dark:text-white dark:outline-white/10 dark:placeholder:text-gray-500 dark:focus:outline-primary"
                      />
                      <div>
                        {errors.email && <p className="text-sm text-red-500">{errors.email}</p>}
                      </div>
                    </div>
                  </div>
                  <div className="sm:col-span-2">
                    <label
                      htmlFor="telephone"
                      className="block text-sm/6 font-semibold text-gray-900 dark:text-white"
                    >
                      Cellulare
                    </label>
                    <div className="mt-2.5">
                      <input
                        id="telephone"
                        name="telephone"
                        value={state.form.telephone}
                        onChange={handleFormChange}
                        type="tel"
                        autoComplete="tel"
                        className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary dark:bg-white/5 dark:text-white dark:outline-white/10 dark:placeholder:text-gray-500 dark:focus:outline-primary"
                      />
                    </div>
                  </div>
                  <div className="sm:col-span-2">
                    <label
                      htmlFor="datetime"
                      className="block text-sm/6 font-semibold text-gray-900 dark:text-white"
                    >
                      Giorno e Ora
                    </label>
                    <input
                      type="datetime-local"
                      name="datetime"
                      value={state.form.datetime}
                      onChange={handleFormChange}
                      id="datetime"
                      className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary dark:bg-white/5 dark:text-white dark:outline-white/10 dark:placeholder:text-gray-500 dark:focus:outline-primary"
                      required
                    />
                  </div>
                  <div className="sm:col-span-2">
                    <label htmlFor="service" className="mb-1 text-sm font-medium text-gray-700">
                      Servizio prescelto
                    </label>
                    <select
                      name="service"
                      id="service"
                      value={state.form.service}
                      onChange={handleFormChange}
                      className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary dark:bg-white/5 dark:text-white dark:outline-white/10 dark:placeholder:text-gray-500 dark:focus:outline-primary"
                      required
                    >
                      <option value="">Seleziona un servizio</option>
                      {services.map(({ label, value }) => (
                        <option key={value} value={value}>
                          {label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="sm:col-span-2">
                    <div className="flex justify-between text-sm/6">
                      <label
                        htmlFor="message"
                        className="block text-sm/6 font-semibold text-gray-900 dark:text-white"
                      >
                        Il tuo messaggio
                      </label>
                      <p id="message-description" className="text-gray-400 dark:text-gray-500">
                        {state.form.message.length}/500 caratteri
                      </p>
                    </div>
                    <div className="mt-2.5">
                      <textarea
                        id="message"
                        name="message"
                        rows={5}
                        value={state.form.message}
                        onChange={handleFormChange}
                        aria-describedby="message-description"
                        className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary dark:bg-white/5 dark:text-white dark:outline-white/10 dark:placeholder:text-gray-500 dark:focus:outline-primary"
                        placeholder="Scrivi qui il tuo messaggio..."
                      />
                      <div>
                        {errors.message && <p className="text-sm text-red-500">{errors.message}</p>}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-10 flex w-full justify-center">
                  <button
                    type="submit"
                    className="w-full rounded-md bg-primary px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:bg-primary dark:hover:bg-primary dark:focus-visible:outline-primary"
                  >
                    Invia
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white py-8 dark:bg-gray-900 sm:py-16">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-2xl divide-y divide-gray-100 dark:divide-white/10 lg:mx-0 lg:max-w-none">
            {/* CONTATTI */}
            <div className="grid grid-cols-1 gap-10 py-16 lg:grid-cols-3">
              <div>
                <h2 className="text-pretty text-4xl font-semibold tracking-tight text-gray-900 dark:text-white">
                  Contatti
                </h2>
                <p className="mt-4 text-base/7 text-gray-600 dark:text-gray-400">
                  Siamo sempre a tua disposizione per collaborazioni, stampa, opportunità lavorative
                  o semplicemente per un saluto.
                </p>
              </div>
              <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:col-span-2 lg:gap-8">
                <div className="hidden rounded-2xl bg-gray-50 p-10 dark:bg-gray-800/50">
                  <h3 className="text-base/7 font-semibold text-gray-900 dark:text-white">
                    Verona
                  </h3>
                  <dl className="mt-3 space-y-1 text-sm/6 text-gray-600 dark:text-gray-400">
                    <div>
                      <dt className="sr-only">Email</dt>
                      <dd>
                        <a
                          href="mailto:partner@nccbrodriver.it"
                          className="font-semibold text-primary dark:text-primary"
                        >
                          verona@nccbrodriver.it
                        </a>
                      </dd>
                    </div>
                    <div className="mt-1">
                      <dt className="sr-only">Telefono</dt>
                      <dd>+39 351 363 1080</dd>
                    </div>
                  </dl>
                </div>

                <div className="hidden rounded-2xl bg-gray-50 p-10 dark:bg-gray-800/50">
                  <h3 className="text-base/7 font-semibold text-gray-900 dark:text-white">
                    Bergamo
                  </h3>
                  <dl className="mt-3 space-y-1 text-sm/6 text-gray-600 dark:text-gray-400">
                    <div>
                      <dt className="sr-only">Email</dt>
                      <dd>
                        <a
                          href="mailto:press@nccbrodriver.it"
                          className="font-semibold text-primary dark:text-primary"
                        >
                          bergamo@nccbrodriver.it
                        </a>
                      </dd>
                    </div>
                    <div className="mt-1">
                      <dt className="sr-only">Telefono</dt>
                      <dd>+39 351 363 1080</dd>
                    </div>
                  </dl>
                </div>

                <div className="hidden rounded-2xl bg-gray-50 p-10 dark:bg-gray-800/50">
                  <h3 className="text-base/7 font-semibold text-gray-900 dark:text-white">
                    Milano
                  </h3>
                  <dl className="mt-3 space-y-1 text-sm/6 text-gray-600 dark:text-gray-400">
                    <div>
                      <dt className="sr-only">Email</dt>
                      <dd>
                        <a
                          href="mailto:careers@nccbrodriver.it"
                          className="font-semibold text-primary dark:text-primary"
                        >
                          milano@nccbrodriver.it
                        </a>
                      </dd>
                    </div>
                    <div className="mt-1">
                      <dt className="sr-only">Telefono</dt>
                      <dd>+39 351 363 1080</dd>
                    </div>
                  </dl>
                </div>

                <div className="rounded-2xl bg-gray-50 p-10 dark:bg-gray-800/50">
                  <h3 className="text-base/7 font-semibold text-gray-900 dark:text-white">
                    Scrivici
                  </h3>
                  <dl className="mt-3 space-y-1 text-sm/6 text-gray-600 dark:text-gray-400">
                    <div>
                      <dt className="sr-only">Email</dt>
                      <dd>
                        <a
                          href="mailto:info@nccbrodriver.it"
                          className="font-semibold text-primary dark:text-primary"
                        >
                          info@nccbrodriver.it
                        </a>
                      </dd>
                    </div>
                    <div className="mt-1">
                      <dt className="sr-only">Telefono</dt>
                      <dd>+39 351 363 1080</dd>
                    </div>
                  </dl>
                </div>
              </div>
            </div>

            {/* SEDI */}
            <div className="grid grid-cols-1 gap-10 py-16 lg:grid-cols-3">
              <div>
                <h2 className="text-pretty text-4xl font-semibold tracking-tight text-gray-900 dark:text-white">
                  Sede operativa
                </h2>
                <p className="mt-4 text-base/7 text-gray-600 dark:text-gray-400">
                  Operiamo principalmente nel Veneto e Lombardia, ma siamo disponibili per servizi
                  su tutto il territorio nazionale.
                </p>
              </div>
              <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:col-span-2 lg:gap-8">
                <div className="rounded-2xl bg-gray-50 p-10 dark:bg-gray-800/50">
                  <h3 className="text-base/7 font-semibold text-gray-900 dark:text-white">
                    Brescia
                  </h3>
                  <address className="mt-3 space-y-1 text-sm/6 not-italic text-gray-600 dark:text-gray-400">
                    <p>Via Cattarello 2F,</p>
                    <p>Chiari (BS) 25032</p>
                  </address>
                </div>
                {/*<div className="rounded-2xl bg-gray-50 p-10 dark:bg-gray-800/50">
                                    <h3 className="text-base/7 font-semibold text-gray-900 dark:text-white">Fiumicino</h3>
                                    <address className="mt-3 space-y-1 text-sm/6 not-italic text-gray-600 dark:text-gray-400">
                                        <p>Aeroporto Leonardo da Vinci</p>
                                        <p>00054 Fiumicino (RM)</p>
                                    </address>
                                </div>*/}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
